import { Link } from "react-router-dom";
import intl from "react-intl-universal";
import { stablesHistoryTabPath } from "./constants";

export const StablesHistoryTypeTabs = ({
  tabs,
  counts,
  activeTab,
  onChange,
  tabsLabelKey = "stables.historyTabsLabel",
  useHistoryRoutes = false,
}) => {
  const safeCounts = counts ?? {};

  return (
    <div className="stables-type-tabs" role="tablist" aria-label={intl.get(tabsLabelKey)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const count = safeCounts[tab.id] ?? 0;
        const className = `stables-type-tab ${isActive ? "stables-type-tab--active" : "stables-type-tab--inactive"}`;

        if (useHistoryRoutes) {
          return (
            <Link
              key={tab.id}
              to={stablesHistoryTabPath(tab.id)}
              role="tab"
              aria-selected={isActive}
              className={`link-no-zoom ${className}`}
            >
              <span className="stables-type-tab__label">{tab.label}</span>
              <span className="stables-type-tab__count">{count}</span>
            </Link>
          );
        }

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={className}
          >
            <span className="stables-type-tab__label">{tab.label}</span>
            <span className="stables-type-tab__count">{count}</span>
          </button>
        );
      })}
    </div>
  );
};
